import { Grid, Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Button } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';

import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import EllipsisWithExclamation from '../../atoms/Icons/EllipsisWithExclamation';
import { getTextWithToolTip } from '../../../core-utils/helper-utils/riskPatientDetailsHelper';

export interface DeleteGroupConfirmModalProps {
  open: boolean;
  handleClose: () => any;
  handleSave: () => any;
  groupName?: string;
  title?: string;
  subTitle?: string;
  interaction?: string;
}

const DeleteGroupConfirmModal: React.FC<DeleteGroupConfirmModalProps> = ({
  open,
  handleClose,
  handleSave,
  groupName,
  title,
  subTitle,
  interaction,
}) => {
  const useStyles = makeStyles()({
    modal: {
      width: '470px',
      height: '280px',
      background: patientAccessTheme.palette.status.white,
      borderRadius: '8px',
      padding: '24px 20px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      flexDirection: 'column',
    },
    alignCenter: {
      textAlign: 'center',
    },
    cancelButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border: '1px solid ' + patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
    saveButton: {
      padding: '9px 16px',
      width: '158px',
      height: '36px',
      background: '#E08083',
      border: '1px solid #E08083',
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
  });
  const { classes } = useStyles();
  const constants =
    componentConstants.ORGANISMS.CARE_NAV_MODALS.DELETE_GROUP_CONFIRM_MODAL;

  return (
    <Modal open={open} onClose={handleClose}>
      <Grid container className={classes.modal}>
        <Grid className={classes.alignCenter}>
          <EllipsisWithExclamation />
        </Grid>
        <Grid className={classes.alignCenter}>
          <Typography
            fontSize="18px"
            lineHeight="26px"
            fontType="semibold"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin="10px 0px 0px 0px"
          >
            {title ?? constants.TITLE}
          </Typography>
          {subTitle ? (
            <Typography
              fontSize="14px"
              lineHeight="24px"
              fontType="normal"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
              margin="0px 0px 10px 0px"
            >
              {subTitle}
            </Typography>
          ) : (
            <>
              <Grid
                container
                direction="row"
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '5px',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  fontSize="14px"
                  lineHeight="24px"
                  fontType="normal"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  margin="5px 0px 10px 0px"
                >
                  {constants.SUB_TITLE1}
                </Typography>
                <Typography
                  style={{
                    fontSize: '14px',
                    lineHeight: '28px',
                    color: patientAccessTheme.palette.primary.main,
                    fontWeight: 500,
                    margin: '-5px 0px 0px 0px',
                    background: `linear-gradient(to right, ${patientAccessTheme.palette.primary[500]} 50%, rgba(255, 255, 255, 0) 0%)`,
                    backgroundPosition: 'bottom',
                    backgroundRepeat: 'repeat-x',
                    backgroundSize: '6px 1px',
                  }}
                >
                  {groupName ? getTextWithToolTip(groupName, 12) : '-'}
                </Typography>
                <Typography
                  fontSize="14px"
                  lineHeight="24px"
                  fontType="normal"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  margin="5px 0px 5px 0px"
                >
                  {constants.SUB_TITLE2}
                </Typography>
              </Grid>

              {interaction && (
                <Typography
                  fontSize="14px"
                  lineHeight="24px"
                  fontType="normal"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  margin="5px 0px"
                >
                  {interaction}
                </Typography>
              )}

              <Typography
                fontSize="14px"
                lineHeight="24px"
                fontType="normal"
                textColor={patientAccessTheme.palette.text.mediumemphasis}
                margin="5px 0px 10px 0px"
              >
                {constants.SUB_TITLE3}
              </Typography>
            </>
          )}
        </Grid>

        <Grid
          container
          style={{
            position: 'absolute',
            bottom: 0,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            marginLeft: '-20px',
            marginBottom: '24px',
          }}
          sx={{
            alignItems: 'center',
          }}
        >
          <Grid style={{ marginRight: '12px' }}>
            <Button
              label={constants.CANCEL}
              variant="outlined"
              className={classes.cancelButton}
              onClick={handleClose}
            />
          </Grid>
          <Grid>
            <Button
              width="158px"
              label={constants.SUBMIT}
              variant="contained"
              className={classes.saveButton}
              disabled={!groupName}
              onClick={() => {
                handleSave && handleSave();
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};
export default DeleteGroupConfirmModal;
